var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useMemo, useEffect } from 'react';
import { useWindowSize } from 'renderer/utils';
import { useMeasure } from 'react-use';
import debounce from 'lodash/debounce';
import Cascader from 'antd/lib/cascader';
import Tag from 'antd/lib/tag';
import { CloseCircleFilled } from '@ant-design/icons';
import styled, { createGlobalStyle } from 'styled-components';
import Drawer from 'antd/lib/drawer';
import Radio from 'antd/lib/radio';
import Button from 'antd/lib/button';
export var CascaderComponent = function (props) {
    var items = props.items, placeholder = props.placeholder, form = props.form, dataKey = props.dataKey, _a = props.mobileDrawerTitle, mobileDrawerTitle = _a === void 0 ? '선택' : _a;
    var isPC = useWindowSize().isPC;
    var _b = useState(0), _ = _b[0], setForceRender = _b[1];
    var _c = useState(false), isOpenMobileCascaderDrawer = _c[0], setOpenMobileCascaderDrawer = _c[1];
    // 모바일 화면에서 items의 계층이 3단계 이상일 경우, 첫 번째 계층을 탭으로 분리하여 표시
    var _d = useState(undefined), firstLevelTab = _d[0], setFirstLevelTab = _d[1];
    var _e = useMeasure(), ref = _e[0], height = _e[1].height;
    var _f = useState(false), isOpenMobileCascaderDropdown = _f[0], setIsOpenMobileCascaderDropdown = _f[1];
    var _g = useState([]), mobileCascaderValue = _g[0], setMobileCascaderValue = _g[1];
    var hasThreeOrMoreLevels = useMemo(function () {
        var getDepth = function (items, depth) {
            if (depth === void 0) { depth = 1; }
            return items.reduce(function (maxDepth, _a) {
                var children = _a.children;
                if (children) {
                    return Math.max(maxDepth, getDepth(children, depth + 1));
                }
                return maxDepth;
            }, depth);
        };
        return getDepth(items) > 2;
    }, [items]);
    var firstLevelTabItems = useMemo(function () {
        var _a, _b, _c;
        return __spreadArray(__spreadArray([], (((_a = items.find(function (item) { return item.value === firstLevelTab; })) === null || _a === void 0 ? void 0 : _a.children) || []), true), (((_c = (_b = items
            .find(function (item) { return item.value !== firstLevelTab; })) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.map(function (innerItem) {
            var _a;
            return (__assign(__assign({}, innerItem), { disabled: true, children: (_a = innerItem.children) === null || _a === void 0 ? void 0 : _a.map(function (innerInnerItem) { return (__assign(__assign({}, innerInnerItem), { disabled: true })); }) }));
        })) || []), true);
    }, [items, firstLevelTab]);
    var displayRender = function (labels) {
        var labelsLength = labels.length;
        if (labelsLength > 1) {
            return "".concat(labels[labelsLength - 2], " / ").concat(labels[labelsLength - 1]);
        }
        return labels[labelsLength - 1];
    };
    var cascaderSearchFilter = function (inputValue, path) {
        return path.some(function (option) {
            return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >
                -1;
        });
    };
    var handleCloseMobileCascaderTag = function (value) {
        var _a;
        var currentValue = form.getFieldValue(dataKey) || [];
        form.setFieldsValue((_a = {},
            _a[dataKey] = currentValue.filter(function (item) {
                return !item.join('__RC_CASCADER_SPLIT__').startsWith(value);
            }),
            _a));
        setMobileCascaderValue(function (prev) {
            return prev.filter(function (item) {
                return item.join('__RC_CASCADER_SPLIT__') !== value;
            });
        });
    };
    var handleClearMobileCascader = function (e) {
        var _a;
        e.stopPropagation();
        form.setFieldsValue((_a = {}, _a[dataKey] = [], _a));
        setForceRender(function (prev) { return prev + 1; });
    };
    var handleClickMobileCascader = debounce(function () {
        setOpenMobileCascaderDrawer(true);
    }, 250);
    var handleCloseMobileCascaderDrawer = function () {
        setIsOpenMobileCascaderDropdown(false);
        setTimeout(function () {
            setOpenMobileCascaderDrawer(false);
        }, 500);
    };
    var handleCompleteMobileCascader = function () {
        var _a;
        form.setFieldsValue((_a = {},
            _a[dataKey] = mobileCascaderValue.map(function (item) {
                var parent = items.find(function (parent) { var _a; return (_a = parent.children) === null || _a === void 0 ? void 0 : _a.some(function (child) { return child.value === item[0]; }); });
                return parent ? __spreadArray([parent.value], item, true) : item;
            }),
            _a));
        handleCloseMobileCascaderDrawer();
    };
    useEffect(function () {
        if (isOpenMobileCascaderDrawer) {
            if (hasThreeOrMoreLevels) {
                var newValue = form.getFieldValue(dataKey) || [];
                setFirstLevelTab(items[0].value);
                setMobileCascaderValue(newValue.map(function (item) { return item.slice(1); }));
            }
            setTimeout(function () {
                setIsOpenMobileCascaderDropdown(true);
            }, 500);
        }
    }, [isOpenMobileCascaderDrawer]);
    return isPC ? (React.createElement(Cascader, { multiple: true, placeholder: placeholder, displayRender: displayRender, maxTagCount: "responsive", showSearch: { filter: cascaderSearchFilter }, options: items, value: form.getFieldValue(dataKey), onChange: function (selectedValue) {
            var _a;
            return form.setFieldsValue((_a = {}, _a[dataKey] = selectedValue, _a));
        } })) : (React.createElement(React.Fragment, null,
        React.createElement(MobileStyledAntdCascader, { multiple: true, placeholder: placeholder, tagRender: function (_a) {
                var value = _a.value, label = _a.label;
                return (React.createElement(Tag, { bordered: false, onClick: function (e) { return e.stopPropagation(); }, closeIcon: true, onClose: function () { return handleCloseMobileCascaderTag(value); } }, label));
            }, displayRender: displayRender, maxTagCount: "responsive", options: items, value: form.getFieldValue(dataKey), allowClear: { clearIcon: React.createElement(CloseCircleFilled, { onClick: handleClearMobileCascader }) }, open: false, onClick: handleClickMobileCascader }),
        React.createElement(MobileCascaderDrawer, { placement: "bottom", height: 448, title: mobileDrawerTitle, extra: hasThreeOrMoreLevels &&
                React.createElement(Radio.Group, { value: firstLevelTab, onChange: function (e) { return setFirstLevelTab(e.target.value); } }, items.map(function (_a) {
                    var value = _a.value, label = _a.label;
                    return React.createElement(Radio.Button, { value: value }, label);
                })), open: isOpenMobileCascaderDrawer, onClose: handleCloseMobileCascaderDrawer, maskClosable: false },
            React.createElement("div", { style: { height: '100%' }, ref: ref },
                React.createElement(MobileCascaderDrawerGlobalStyle, null),
                React.createElement(MobileStyledAntdCascader, { multiple: true, placeholder: "\uAC80\uC0C9", tagRender: function (_a) {
                        var label = _a.label, value = _a.value;
                        return (React.createElement(Tag, { bordered: false, closeIcon: true, onClose: function () { return setMobileCascaderValue(function (prev) { return prev.filter(function (item) { return item.join('__RC_CASCADER_SPLIT__') !== value; }); }); } }, label));
                    }, displayRender: displayRender, maxTagCount: "responsive", showSearch: { filter: cascaderSearchFilter }, options: firstLevelTabItems, dropdownStyle: {
                        boxShadow: 'none',
                        width: 'calc(100% - 24px)',
                        height: height - 36,
                    }, open: isOpenMobileCascaderDropdown, value: mobileCascaderValue, onChange: function (selectedValue) { return setMobileCascaderValue(selectedValue); } })),
            React.createElement(MobileCascaderDrawerFooter, null,
                React.createElement(Button, { onClick: function () { return setMobileCascaderValue([]); } }, "\uCD08\uAE30\uD654"),
                React.createElement(Button, { type: "primary", onClick: handleCompleteMobileCascader },
                    mobileCascaderValue.length > 0 && "".concat(mobileCascaderValue.length, "\uAC1C "),
                    "\uC120\uD0DD\uC644\uB8CC")))));
};
var MobileStyledAntdCascader = styled(Cascader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  & .ant-tag {\n    margin-inline-end: 4px;\n    background-color: var(--Color-Border-ColorSplit, rgba(0, 0, 0, 0.06));\n  }\n"], ["\n  width: 100%;\n  & .ant-tag {\n    margin-inline-end: 4px;\n    background-color: var(--Color-Border-ColorSplit, rgba(0, 0, 0, 0.06));\n  }\n"])));
var MobileCascaderDrawer = styled(Drawer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 8px 8px 0 0;\n  & .ant-radio-group {\n    display: flex;\n    column-gap: 8px;\n    & > .ant-radio-button-wrapper {\n      border-width: 1px;\n      border-radius: 32px;\n      padding: 0 15px;\n      height: 32px;\n      &:not(:first-child)::before {\n        display: none;\n      }\n    }\n  }\n  & > .ant-drawer-body {\n    padding: 8px 12px 49px;\n    max-height: 392px;\n  }\n"], ["\n  border-radius: 8px 8px 0 0;\n  & .ant-radio-group {\n    display: flex;\n    column-gap: 8px;\n    & > .ant-radio-button-wrapper {\n      border-width: 1px;\n      border-radius: 32px;\n      padding: 0 15px;\n      height: 32px;\n      &:not(:first-child)::before {\n        display: none;\n      }\n    }\n  }\n  & > .ant-drawer-body {\n    padding: 8px 12px 49px;\n    max-height: 392px;\n  }\n"])));
var MobileCascaderDrawerGlobalStyle = createGlobalStyle(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  .ant-cascader-dropdown > div {\n    height: 100%;\n    & > .ant-cascader-menus {\n      height: 100%;\n      & > .ant-cascader-menu {\n        flex: 1;\n        height: 100%;\n        & > .ant-cascader-menu-item-disabled {\n          display: none;\n        }\n      }\n    }\n  }\n"], ["\n  .ant-cascader-dropdown > div {\n    height: 100%;\n    & > .ant-cascader-menus {\n      height: 100%;\n      & > .ant-cascader-menu {\n        flex: 1;\n        height: 100%;\n        & > .ant-cascader-menu-item-disabled {\n          display: none;\n        }\n      }\n    }\n  }\n"])));
var MobileCascaderDrawerFooter = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 12px;\n  border-top: 1px solid var(--Color-Border-ColorSplit, rgba(0, 0, 0, 0.06));\n  padding: 8px;\n  width: calc(100% - 24px);\n  background-color: #FFF;\n  display: flex;\n  column-gap: 8px;\n  & > .ant-btn {\n    flex: 1;\n  }\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 12px;\n  border-top: 1px solid var(--Color-Border-ColorSplit, rgba(0, 0, 0, 0.06));\n  padding: 8px;\n  width: calc(100% - 24px);\n  background-color: #FFF;\n  display: flex;\n  column-gap: 8px;\n  & > .ant-btn {\n    flex: 1;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
